import { IconButton, styled } from '@mui/material';

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  border: "1px solid #c1c1c1",
  borderRadius: "5px",
  width: 45,
  height: 45,
  color: "#ffffff",
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  }
}));


/* const StyledIconButton = styled(IconButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`, // Uses theme colors
  color: theme.palette.primary.main,
  borderRadius: theme.shape.borderRadius,
  // Responsive styles
  [theme.breakpoints.down('sm')]: {
    width: 35,
    height: 35,
  }
})); */